import React from 'react';
import { FormattedMessage } from '../../../../util/reactIntl';
import { NamedLink, ListingCard } from '../../../../components';

import css from './SectionActivities.module.css';

/**
 * An activity row ("All activities", "Great for {child}") of real listings on the shared
 * (redesigned) ListingCard. `origin` (the parent's saved location) powers the cards' distance chips;
 * `seeAllSearch` carries the row's filters into the search page. A row with nothing to show hides --
 * unless the caller passes `emptyMessage` (the per-child rows do), in which case the row stays with
 * that message + a browse-all link, so a child is never silently missing from the homepage.
 */
const SectionActivities = props => {
  const { title, subtitle, listings = [], origin, seeAllSearch, emptyMessage } = props;

  if (listings.length === 0 && !emptyMessage) {
    return null;
  }

  return (
    <section className={css.root}>
      <div className={css.inner}>
        <div className={css.header}>
          <div className={css.headingGroup}>
            <h2 className={css.heading}>{title}</h2>
            {subtitle ? <p className={css.subtitle}>{subtitle}</p> : null}
          </div>
          <NamedLink
            name="SearchPage"
            to={seeAllSearch ? { search: seeAllSearch } : {}}
            className={css.seeAll}
          >
            <FormattedMessage id="SectionActivities.seeAll" />
          </NamedLink>
        </div>

        {listings.length === 0 ? (
          <div className={css.emptyRow}>
            <p className={css.emptyMessage}>{emptyMessage}</p>
            <NamedLink name="SearchPage" className={css.emptyBrowseLink}>
              <FormattedMessage id="SectionActivities.browseAll" />
            </NamedLink>
          </div>
        ) : null}

        {listings.length > 0 ? (
        <ul className={css.grid}>
          {listings.map(listing => (
            <li key={listing.id.uuid} className={css.item}>
              <ListingCard listing={listing} origin={origin} />
            </li>
          ))}
        </ul>
        ) : null}
      </div>
    </section>
  );
};

export default SectionActivities;
